$(document).ready(function () {
  let p = $("body").attr("p");

  if (p === "organizer_settings_users") {
    let organizer_new_ajax_lock = false;
    let currentModuleIds = [];
    let currentModuleIdLock = false;

    function updateGroupChecks($select) {
      const $menu = $select.siblings('.dropdown-menu');
      $select.find('optgroup').each(function() {
        const $optgroup = $(this);
        const groupLabel = $optgroup.attr('label');
        const totalOptions = $optgroup.find('option').length;
        const selectedOptions = $optgroup.find('option:selected').length;
        const $header = $menu.find('.dropdown-header').filter(function() {
          return $(this).text().trim() === groupLabel;
        });
        let $checkmark = $header.find('.check-mark');
        if ($checkmark.length === 0) {
          $checkmark = $('<span class="bs-ok-default check-mark"></span>');
          $header.prepend($checkmark);
        }
        if (totalOptions > 0 && totalOptions === selectedOptions) {
          $checkmark.removeClass('d-none');
        } else {
          $checkmark.addClass('d-none');
        }
      });
    }

    function attachHeaderClickHandlers($select) {
      const $menu = $select.siblings('.dropdown-menu');

      $menu.find('.dropdown-header').each(function() {
        const headerElement = this;

        const newHeader = headerElement.cloneNode(true);
        headerElement.parentNode.replaceChild(newHeader, headerElement);

        newHeader.addEventListener("click", function (e) {
          e.stopPropagation();

          const groupLabel = newHeader.textContent.trim();
          const $optgroup = $select.find(`optgroup[label="${groupLabel}"]`);

          if ($optgroup.length > 0) {
            const $options = $optgroup.find('option');
            const totalOptions = $options.length;
            const selectedOptions = $optgroup.find('option:selected').length;
            const shouldSelectAll = selectedOptions < totalOptions;

            $options.prop('selected', shouldSelectAll);

            // Refresh the selectpicker
            $select.selectpicker('refresh');

            // **RE-ATTACH handlers after refresh**
            attachHeaderClickHandlers($select);

            updateGroupChecks($select);
          }
        });
      });
    }

    $(document).on("show.bs.select", ".modules-selector", function () {
      if (!currentModuleIdLock) {
        currentModuleIdLock = true;
        currentModuleIds = $(this).val() || [];
      }

      const $select = $(this);
      const $menu = $select.siblings('.dropdown-menu');

      updateGroupChecks($select);

      attachHeaderClickHandlers($select);
    });

    $(document).on('changed.bs.select', '.modules-selector', function(e, clickedIndex) {
      if (clickedIndex !== undefined) {
        updateGroupChecks($(this));
      }
    });

    $(document).on('loaded.bs.select', '.modules-selector', function() {
      updateGroupChecks($(this));
    });

    $(document).on("hidden.bs.select", ".modules-selector", function () {
      $(".dropdown-menu .dropdown-header").each(function() {
        $(this).off("click");
        this.onclick = null;

        const el = this.cloneNode(true);
        this.replaceWith(el);

        el.onclick = null;
        el.addEventListener("click", () =>
          console.log("Native click works:", $(el).text().trim())
        );
      });

      if (!organizer_new_ajax_lock) {
        organizer_new_ajax_lock = true;
        let moduleIds = $(this).val() || [];
        let userId = $(this).attr("data-user-id");
        let organizerId = $(this).attr("data-organizer-id");

        if (arraysEqual(currentModuleIds, moduleIds)) {
          setTimeout(function () {
            organizer_new_ajax_lock = false; // Reset the lock if no changes were made
          }, 1000);

          return;
        }

        $.ajax({
          type: "POST",
          url: "/ajax/organizer_settings_users/update_module",
          data: {
            userId: userId,
            organizerId: organizerId,
            modules: moduleIds,
          },
        })
          .done(function (data) {
            popupAlert();

            setTimeout(function () {
              currentModuleIdLock = false;
            }, 500);
          })

          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              prependAlert(
                "#div_organizer_settings_button",
                data.responseJSON.error_message,
                "danger",
                null,
                "#organizer_settings_form"
              );
            }
          })
          .always(function () {
            organizer_new_ajax_lock = false; // Reset the lock after the request completes
          });
      }
    });

    function arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      // Sort arrays to ensure comparison is not order-dependent
      a = a.slice().sort();
      b = b.slice().sort();

      for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
  }
});
